<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			height="60vh"
		>
			<el-table-column prop="id" label="ID" width="80px"></el-table-column>

			<el-table-column prop="platform" label="平台" width="100px">
				<template slot-scope="scope">
					<el-tag size="small">{{ scope.row.platform }}</el-tag>
				</template>
			</el-table-column>

			<el-table-column prop="title" label="事件标题" min-width="200px" show-overflow-tooltip>
			</el-table-column>

			<el-table-column prop="category" label="分类" width="120px">
			</el-table-column>

			<el-table-column label="市场数量" width="90px">
				<template slot-scope="scope">
					<span>{{ scope.row.market_count || 0 }}</span>
				</template>
			</el-table-column>

			<el-table-column label="总交易量" width="120px">
				<template slot-scope="scope">
					<span>{{ formatNumber(scope.row.total_volume) }}</span>
				</template>
			</el-table-column>

			<el-table-column label="审核状态" width="100px">
				<template slot-scope="scope">
					<el-tag
						:type="getReviewStatusType(scope.row.review_status)"
						size="small"
					>
						{{ scope.row.review_status_text }}
					</el-tag>
				</template>
			</el-table-column>

			<el-table-column label="平台状态" width="100px">
				<template slot-scope="scope">
					<el-tag
						:type="getPlatformStatusType(scope.row.status)"
						size="small"
					>
						{{ scope.row.platform_status_text }}
					</el-tag>
				</template>
			</el-table-column>

			<el-table-column prop="create_time" label="创建时间" width="160px">
			</el-table-column>

			<el-table-column fixed="right" label="操作" width="200px">
				<template slot-scope="scope">
					<el-button
						type="text"
						size="small"
						@click="handleDetail(scope.row)"
					>
						详情
					</el-button>
					<el-button
						v-if="scope.row.review_status == 0"
						type="text"
						size="small"
						@click="handleReview(scope.row, 1)"
					>
						发布
					</el-button>
					<el-button
						v-if="scope.row.review_status == 0"
						type="text"
						size="small"
						style="color: #f56c6c"
						@click="handleReview(scope.row, 2)"
					>
						拒绝
					</el-button>
					<el-button
						v-if="scope.row.review_status == 1"
						type="text"
						size="small"
						style="color: #909399"
						@click="handleReview(scope.row, 0)"
					>
						撤回
					</el-button>
					<el-button
						type="text"
						size="small"
						@click="viewMarkets(scope.row)"
					>
						查看市场
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 详情对话框 -->
		<el-dialog
			title="事件详情"
			:visible.sync="detailDialogVisible"
			width="800px"
			:append-to-body="true"
		>
			<div v-if="currentEvent" class="detail-content">
				<el-descriptions :column="2" border>
					<el-descriptions-item label="ID">
						{{ currentEvent.id }}
					</el-descriptions-item>
					<el-descriptions-item label="平台">
						<el-tag size="small">{{ currentEvent.platform }}</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="标题" :span="2">
						{{ currentEvent.title }}
					</el-descriptions-item>
					<el-descriptions-item label="分类">
						{{ currentEvent.category || "-" }}
					</el-descriptions-item>
					<el-descriptions-item label="市场数量">
						{{ currentEvent.market_count || 0 }}
					</el-descriptions-item>
					<el-descriptions-item label="总交易量">
						{{ formatNumber(currentEvent.total_volume) }}
					</el-descriptions-item>
					<el-descriptions-item label="总流动性">
						{{ formatNumber(currentEvent.total_liquidity) }}
					</el-descriptions-item>
					<el-descriptions-item label="审核状态">
						<el-tag
							:type="getReviewStatusType(currentEvent.review_status)"
							size="small"
						>
							{{ currentEvent.review_status_text }}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="平台状态">
						<el-tag
							:type="getPlatformStatusType(currentEvent.status)"
							size="small"
						>
							{{ currentEvent.platform_status_text }}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="开始时间">
						{{ currentEvent.start_date || "-" }}
					</el-descriptions-item>
					<el-descriptions-item label="结束时间">
						{{ currentEvent.end_date || "-" }}
					</el-descriptions-item>
					<el-descriptions-item label="创建时间">
						{{ currentEvent.create_time }}
					</el-descriptions-item>
					<el-descriptions-item label="更新时间">
						{{ currentEvent.update_time }}
					</el-descriptions-item>
					<el-descriptions-item label="来源链接" :span="2">
						<a
							v-if="currentEvent.source_url"
							:href="currentEvent.source_url"
							target="_blank"
							style="color: #409eff"
						>
							{{ currentEvent.source_url }}
						</a>
						<span v-else>-</span>
					</el-descriptions-item>
					<el-descriptions-item label="描述" :span="2">
						<div class="description-text">
							{{ currentEvent.description || "-" }}
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="标签" :span="2">
						<el-tag
							v-for="(tag, index) in currentEvent.tags"
							:key="index"
							size="small"
							style="margin-right: 5px"
						>
							{{ tag }}
						</el-tag>
						<span v-if="!currentEvent.tags || currentEvent.tags.length == 0">-</span>
					</el-descriptions-item>
				</el-descriptions>
			</div>
		</el-dialog>

		<!-- 市场列表对话框 -->
		<el-dialog
			title="市场列表"
			:visible.sync="marketsDialogVisible"
			width="1200px"
			:append-to-body="true"
		>
			<div v-if="currentEventForMarkets" class="markets-content">
				<div class="event-info" style="margin-bottom: 20px;">
					<el-descriptions :column="2" border size="small">
						<el-descriptions-item label="事件ID">
							{{ currentEventForMarkets.id }}
						</el-descriptions-item>
						<el-descriptions-item label="事件标题">
							{{ currentEventForMarkets.title }}
						</el-descriptions-item>
						<el-descriptions-item label="平台">
							<el-tag size="small">{{ currentEventForMarkets.platform }}</el-tag>
						</el-descriptions-item>
						<el-descriptions-item label="市场数量">
							{{ currentEventForMarkets.market_count || 0 }}
						</el-descriptions-item>
					</el-descriptions>
				</div>

				<el-table
					border
					:data="marketsData"
					:header-cell-style="{ 'text-align': 'center' }"
					:cell-style="{ 'text-align': 'center' }"
					tooltip-effect="dark"
					style="width: 100%"
					max-height="400px"
					v-loading="marketsLoading"
				>
					<el-table-column prop="id" label="ID" width="80px"></el-table-column>
					<el-table-column prop="title" label="市场标题" min-width="180px" show-overflow-tooltip>
					</el-table-column>
					<el-table-column label="结果选项" min-width="200px">
						<template slot-scope="scope">
							<div v-if="scope.row.outcomes && scope.row.outcomes.length > 0" style="display: flex; flex-wrap: wrap; gap: 5px;">
								<el-tag
									v-for="(outcome, idx) in scope.row.outcomes"
									:key="idx"
									size="small"
									:type="getOutcomeTagType(idx)"
								>
									{{ outcome.name }}: {{ formatPrice(outcome.price) }}
								</el-tag>
							</div>
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column label="交易量" width="110px">
						<template slot-scope="scope">
							<span>{{ formatNumber(scope.row.volume) }}</span>
						</template>
					</el-table-column>
					<el-table-column label="流动性" width="110px">
						<template slot-scope="scope">
							<span>{{ formatNumber(scope.row.liquidity) }}</span>
						</template>
					</el-table-column>
					<el-table-column label="状态" width="100px">
						<template slot-scope="scope">
							<el-tag
								:type="getMarketStatusType(scope.row.status)"
								size="small"
							>
								{{ getMarketStatusText(scope.row.status) }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="create_time" label="创建时间" width="160px">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="100px">
						<template slot-scope="scope">
							<el-button
								type="text"
								size="small"
								@click="handleMarketDetail(scope.row)"
							>
								详情
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>

		<!-- 市场详情对话框 -->
		<el-dialog
			title="市场详情"
			:visible.sync="marketDetailDialogVisible"
			width="800px"
			:append-to-body="true"
		>
			<div v-if="currentMarket" class="detail-content">
				<el-descriptions :column="2" border>
					<el-descriptions-item label="ID">
						{{ currentMarket.id }}
					</el-descriptions-item>
					<el-descriptions-item label="事件ID">
						{{ currentMarket.event_id }}
					</el-descriptions-item>
					<el-descriptions-item label="标题" :span="2">
						{{ currentMarket.title }}
					</el-descriptions-item>
					<el-descriptions-item label="交易量">
						{{ formatNumber(currentMarket.volume) }}
					</el-descriptions-item>
					<el-descriptions-item label="流动性">
						{{ formatNumber(currentMarket.liquidity) }}
					</el-descriptions-item>
					<el-descriptions-item label="当前价格">
						{{ formatNumber(currentMarket.current_price) }}
					</el-descriptions-item>
					<el-descriptions-item label="状态">
						<el-tag
							:type="getMarketStatusType(currentMarket.status)"
							size="small"
						>
							{{ getMarketStatusText(currentMarket.status) }}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="创建时间">
						{{ currentMarket.create_time }}
					</el-descriptions-item>
					<el-descriptions-item label="更新时间">
						{{ currentMarket.update_time }}
					</el-descriptions-item>
					<el-descriptions-item label="描述" :span="2">
						<div class="description-text">
							{{ currentMarket.description || "-" }}
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="结果选项" :span="2">
						<div v-if="currentMarket.outcomes && currentMarket.outcomes.length > 0">
							<el-table
								:data="currentMarket.outcomes"
								border
								size="small"
								style="margin-top: 10px;"
							>
								<el-table-column prop="name" label="选项名称" min-width="150px">
								</el-table-column>
								<el-table-column label="当前价格" width="120px">
									<template slot-scope="scope">
										<span>{{ formatPrice(scope.row.price) }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="token_id" label="Token ID" width="120px">
								</el-table-column>
							</el-table>
						</div>
						<span v-else>-</span>
					</el-descriptions-item>
				</el-descriptions>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { updateReviewStatus } from "@/api/prediction";

export default {
	name: "PredictionEventTable",
	props: {
		tableData: {
			type: Array,
			default: () => [],
		},
		platformList: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			detailDialogVisible: false,
			currentEvent: null,
			marketsDialogVisible: false,
			currentEventForMarkets: null,
			marketsData: [],
			marketsLoading: false,
			marketDetailDialogVisible: false,
			currentMarket: null,
		};
	},
	methods: {
		// 格式化数字
		formatNumber(num) {
			if (!num) return "0";
			return parseFloat(num).toLocaleString();
		},

		// 获取审核状态颜色
		getReviewStatusType(status) {
			const map = {
				0: "info", // 草稿
				1: "success", // 已发布
				2: "danger", // 已拒绝
			};
			return map[status] || "info";
		},

		// 获取平台状态颜色
		getPlatformStatusType(status) {
			const map = {
				active: "success",
				closed: "info",
				ended: "warning",
			};
			return map[status] || "info";
		},

		// 查看详情
		handleDetail(row) {
			this.currentEvent = row;
			this.detailDialogVisible = true;
		},

		// 审核操作
		handleReview(row, reviewStatus) {
			const statusText = {
				0: "撤回到草稿",
				1: "发布",
				2: "拒绝",
			};

			this.$confirm(
				`确定要${statusText[reviewStatus]}该事件吗？`,
				"提示",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}
			)
				.then(() => {
					updateReviewStatus({
						id: row.id,
						review_status: reviewStatus,
					})
						.then((res) => {
							if (res.code == 200) {
								this.$message.success("操作成功");
								this.$emit("refresh");
							} else {
								this.$message.error(res.message || "操作失败");
							}
						})
						.catch((error) => {
							this.$message.error(error.message || "操作失败");
						});
				})
				.catch(() => {});
		},

		// 查看市场
		viewMarkets(row) {
			this.currentEventForMarkets = row;
			this.marketsDialogVisible = true;
			this.getMarketsData(row.id);
		},

		// 获取市场数据
		getMarketsData(eventId) {
			this.marketsLoading = true;
			this.marketsData = [];
			
			const { getMarketsByEvent } = require("@/api/prediction");
			getMarketsByEvent({ event_id: eventId })
				.then((res) => {
					console.log('Markets response:', res);
					if (res.code == 200) {
						// 尝试多种可能的数据结构
						this.marketsData = res.data.data || res.data || [];
						console.log('Markets data:', this.marketsData);
					} else {
						this.marketsData = [];
						this.$message.error(res.message || "获取市场数据失败");
					}
					this.marketsLoading = false;
				})
				.catch((error) => {
					console.error('Markets error:', error);
					this.$message.error(error.message || "获取市场数据失败");
					this.marketsData = [];
					this.marketsLoading = false;
				});
		},

		// 获取市场状态颜色
		getMarketStatusType(status) {
			const map = {
				active: "success",
				closed: "info",
				ended: "warning",
			};
			return map[status] || "info";
		},

		// 获取市场状态文本
		getMarketStatusText(status) {
			const map = {
				active: "活跃",
				closed: "关闭",
				ended: "结束",
			};
			return map[status] || status;
		},

		// 查看市场详情
		handleMarketDetail(row) {
			this.currentMarket = row;
			this.marketDetailDialogVisible = true;
		},

		// 格式化价格（保留小数）
		formatPrice(price) {
			if (!price) return "0.00";
			const num = parseFloat(price);
			return num.toFixed(4);
		},

		// 获取结果选项标签颜色
		getOutcomeTagType(index) {
			const types = ["primary", "success", "warning", "danger", "info"];
			return types[index % types.length];
		},
	},
};
</script>

<style scoped>
.detail-content {
	max-height: 600px;
	overflow-y: auto;
}
.description-text {
	max-height: 200px;
	overflow-y: auto;
	line-height: 1.6;
	white-space: pre-wrap;
	word-break: break-word;
}
.markets-content {
	max-height: 600px;
}
</style>